var map = {
	"./Vip_Card_1.png": "6219",
	"./Vip_Card_2.png": "2073",
	"./Vip_Card_3.png": "b98d",
	"./Vip_Card_4.png": "717a",
	"./Vip_Card_5.png": "28d4",
	"./Vip_Card_6.png": "363f",
	"./Vip_Card_7.png": "978b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1315";